export default __webpack_public_path__ + "img/rule44back-69d88f8a.png";